// import 'slick-carousel';
import '../plugins/slick.min';

/**
 * @desc    SlickJS Configuration
 * @see     http://kenwheeler.github.io/slick/
 * @see     https://github.com/kenwheeler/slick/#settings
 */
function init() {
	// carousel with images slider configuration
	$('.car-w-img-slider').slick({
		dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 3,
		slidesToScroll: 3,
		autoplay: true,
	    autoplaySpeed: 5000,
	    pauseOnHover: false,
	    responsive: [
	    	{
	    		breakpoint: 992,
	    		settings: {
	    			slidesToShow: 1,
	    			slidesToScroll: 1,
	    		}
	    	}
	    ]
	});

	$('.facts-slider-wrap').slick({
	    dots: true,
		arrows: false,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
	    autoplaySpeed: 5000,
	    pauseOnHover: false,
	});
	$('.resources-slider-wrap').slick({
	    dots: false,
		arrows: true,
		centerMode: true,
		infinite: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false,
	    autoplaySpeed: 5000,
	    pauseOnHover: false,
		nextArrow: $('.r-next'),
		prevArrow: $('.r-previous'),
	});
}

/**
 * Public API
 * @type {Object}
 */
module.exports = {
	init: init
};



// WEBPACK FOOTER //
// ./scripts/components/slick-slider.js